const reglPromise = import("../../../_snowpack/pkg/regl.js");
class WebglCanvas {
  constructor(webglQuery) {
    this.maxDrawBufferSize = 2048;
    this.IsProgramValid = false;
    this._webglDom = document.querySelector(webglQuery);
    this.IsProgramValid = this._webglDom != null;
    if (this.IsProgramValid) {
      this.RegisterDomEvent();
      this.AutoSetCanvasSize();
    }
  }
  RegisterDomEvent() {
    window.addEventListener("resize", () => {
      this.AutoSetCanvasSize();
    });
  }
  async CreatREGLCanvas(webglDom) {
    let regl = await reglPromise;
    return regl.default({
      canvas: webglDom
    });
  }
  AutoSetCanvasSize() {
    this.SetCanvasToSceenSize(this._webglDom.clientWidth, this._webglDom.clientHeight);
  }
  SetCanvasToSceenSize(displayWidth, displayHeight) {
    let adjust_height = this.maxDrawBufferSize * (displayHeight / displayWidth);
    let adjust_width = this.maxDrawBufferSize;
    this._webglDom.width = adjust_width;
    this._webglDom.height = adjust_height;
  }
  ScreenPositionToClipSpace(x, y) {
    let scaleX = x / this._webglDom.clientWidth * 2 - 1;
    let scaleY = y / this._webglDom.clientHeight * 2 - 1;
    return {x: scaleX, y: scaleY};
  }
  ClipSpaceToScreenPosition(x, y) {
    let scaleX = (x + 1 * 0.5) * this._webglDom.clientWidth;
    let scaleY = (y + 1 * 0.5) * this._webglDom.clientHeight;
    return {x: scaleX, y: scaleY};
  }
  ReadPixel(x, y) {
    return Array.from(this._reglContext.read({
      x,
      y,
      width: 1,
      height: 1,
      data: new Uint8Array(4)
    })).map((x2) => x2 / 255);
  }
}
export default WebglCanvas;
